// <JC

import React, { useState } from 'react';
import DeleteForever from "@mui/icons-material/DeleteForever";

// Composant pour l'affichage d'une seule languette (tag)
const Tag = ({ tag, onRemove }) => {
  
  // Fonction pour gérer la suppression avec confirmation
  const handleDelete = () => {
    // Utilise window.confirm() pour l'alerte de confirmation
    const isConfirmed = window.confirm(
      `Êtes-vous sûr de vouloir supprimer la correspondance : "${tag}" ?`
    );

    if (isConfirmed) {
      // Si confirmé, appelle la fonction onRemove (qui est le removeTagFromOperation)
      onRemove();
    }
  };

  return (
    <span style={{ 
        marginRight: '5px', 
        padding: '4px 10px', 
        backgroundColor: '#F7F7F7', 
        borderRadius: '10px', 
        fontSize: '0.9em', 
        display: 'inline-flex', 
        alignItems: 'center' 
    }}>
      {tag}
      <DeleteForever
          className="delete-icon-operation red cursor-pointer"
          onClick={handleDelete}
          title={"Supprimer la correspondance"}
      />
    </span>
  );
};

function OperationItem({ operation, onAddTag, onRemoveTag }) {
  const [inputValue, setInputValue] = useState('');

  const handleKeyPress = (event) => {
    // Déclenche l'ajout du tag à la pression de la touche 'Entrée'
    if (event.key === 'Enter' && inputValue.trim()) {
      onAddTag(operation.id, inputValue);
      setInputValue('');
      event.preventDefault();
    }
  };

  return (
    <div style={{ backgroundColor: '#fff', border: '1px solid #fff', padding: '15px', marginBottom: '15px', borderRadius: '5px' }}>
      
      <div className="mb-3">
        {/* Affichage des données de l'opération */}
      
        <h4 style={{ margin: '0 15px 5px 0', display: 'inline-block' }}>{operation.brand} - <strong>{operation.operation_type}</strong></h4>

        {/* Champ de saisie pour un nouveau tag */}
        <input
            type="text"
            placeholder="Saisissez une nouvelle correspondance ici puis tapez sur Entrée"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyPress}
            style={{ padding: '5px', width: '50%', border: '1px solid #e4e4e4ff', borderRadius: '4px', display: 'inline-block' }}
        />
    </div>
      
      
      
      
      
      {/* Affichage des Tags existants */}
      <div style={{ minHeight: '30px', marginBottom: '10px' }}>
        {operation.tags.length > 0 ? (
          operation.tags.map(tag => (
            <Tag 
              key={tag} 
              tag={tag} 
              onRemove={() => onRemoveTag(operation.id, tag)} 
            />
          ))
        ) : (
          <p style={{ fontSize: '0.75em', color: '#ff6f6f' }}>Aucune correspondance</p>
        )}
      </div>
      
      
    </div>
  );
}

export default OperationItem;

// JC>